import React, { useState, useContext, useRef, useEffect } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { AppDataContext, VLink } from "../AppDataContext"
import useNetwork from '../../useNetwork';
import { Helmet } from "react-helmet";
import useInfiniteScroll from "../../useInfiniteScroll";
import { LotTile } from '../auction/LotTile';
import { BidDialog } from '../auction/BidDialog';
import { Modal } from 'bootstrap';
import { urlEncodeText, computeSystemTimeDifference, getSecondsToTime, toGMT } from '../../helpers';
import { Loader } from '../Loader';
import CurrencyFormat from 'react-currency-format';
import { ConfirmDialog } from '../ConfirmDialog';

export function Auctioneers(props) {

	const context = useContext(AppDataContext);
	const { loading, networkError, netRequest, netRenderError } = useNetwork(true);
	const history = useHistory();
	const [message, setMessage] = useState(null);

	const startIx = useRef(0);
	const pageSize = 8;


	const [isFetching, setIsFetching, isDone, setIsDone] = useInfiniteScroll(fetchSellers);
	const [endReached, setEndReached] = useState(false);
	const [totalCount, setTotalCount] = useState(null);
	const totalCountRef = useRef(null);

	const [sellers, setSellers] = useState([]);

	// this useEffect has [] as the parms, so only gets call on didMount
	useEffect(() => {

		fetchSellers(true);

		// clean up if this effect gets called again
		return () => {
		};
	}, []);


	function fetchSellers(fromBeginning) {

		const getNextSellers = async (startingAt) => {
			if (totalCountRef.current == null || startingAt < totalCountRef.current) {
				let itemsToFetch = pageSize;

				const url = 'api/site/getsellers/' + startingAt + '/' + itemsToFetch;
				console.log(url);
				const response = await netRequest(url);

				if (response.data != null) {

					totalCountRef.current = response.data.totalCount;
					setTotalCount(response.data.totalCount);

					// set our next starting point
					startIx.current = startingAt + itemsToFetch;

					const endReached = startIx.current >= response.data.totalCount;
					setIsDone(endReached);
					setEndReached(endReached);

					if (startingAt == 0)
						setSellers(response.data.sellers);
					else
						setSellers([...sellers, ...response.data.sellers]);
				}
			} else {
				setEndReached(true);
			}
			setIsFetching(false);
		};

		// if the infinite scroll calls us, the first param is false
		let startingAt = fromBeginning === true ? 0 : startIx.current;

		getNextSellers(startingAt);
	};


	const onFollow = async (seller) => {
		setMessage(null);

		const url = 'api/site/setfollow';
		const postData = {
			secureId: seller.secureId,
			isFavorite: !seller.isFollowing,
		};

		const response = await netRequest(url, postData);

		if (response.data != null) {
			setMessage("An error occurred");
		} else {
			seller.isFollowing = !seller.isFollowing;
			// rebuild the screen
			setSellers([...sellers]);
		}

	};

	return (
		<>
			<Helmet>
				<title>Auctioneers</title>
			</Helmet>
			<div class="tab-pane container h-100 py-3 px-0 active" id="auctioneers">
				<div class="btn-group">
					<VLink to="/dashboard/search" class="btn btn-secondary">Searches</VLink>
					<button class="btn btn-primary active">Auctioneers</button>
				</div>
				{message && <div>{message}</div> }
                <div class="row mt-3">
					{sellers.map((s) =>
						<div key={"seller" + s.secureId} class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
							<div className={"auction--item" + (s.isFollowing ? "" : " opacity-50")}>
								<div class="auction--item__content border-radius-huge">
									<div class="auction--item__content--details p-3">
										<VLink to={"/seller/" + s.secureId} title="" className={"text-center"}>
											<img src={"api/site/SellerLogo/" + s.secureId} class="d-block mx-auto my-3 logo--md" title={s.companyName} alt={s.companyName} />
										</VLink>
										<h3 class="text-center">
											<VLink to={"/seller/" + s.secureId} title="" className={"text-center"}>{s.companyName}</VLink>
										</h3>

									</div>
									<div class="auction--item__content--actions">
										<div class="row py-2 px-0 m-0">
											<div class="col text-center">
												<button class="btn btn-text" onClick={() => onFollow(s)}><i class="bi bi-star-fill me-2"></i>
													{s.isFollowing ? "Unfollow" : "Follow"}
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
                    ) }

					{isFetching && !isDone && <div>Fetching More...</div>}
					{(totalCount > 0 && endReached) && <div class="col-12"><p class="text-center end-of-auction">End of Auctioneers</p></div>}
					{(!isFetching && totalCount > 0 && !endReached) &&
						<div class="col-12 mb-3 text-end">

							<button onClick={fetchSellers} class="btn btn-secondary" title="Show More...">
								Show More <i class="bi bi-arrow-right-short"></i>
							</button>
						</div>
					}
					{totalCount == 0 && <div class="col-12"><p class="text-center end-of-auction">You are not following any Auctioneers</p></div>}

                </div>


            </div>
		</>
    );

}
